import { AxiosInstance, AxiosResponse } from "axios"

import { GetPropertiesTestRequestParams, ResponseData } from "../common"

export type PropertyTypeConfig = {
  typeId: number | string
  typeCode: string
  typeDescription: string
  link: string
  linkTitle: string
  titleColor?: string
  isSaveClass?: boolean
  hideOn?: "none" | "web" | "all" | "mobile"
  showEvenRows?: boolean
  keys: GetPropertiesTestRequestParams
}

export interface GetPropertyConfigsAPIResponseData extends ResponseData {
  data: PropertyTypeConfig[]
}

export interface GetPropertyConfigsAPIResponse extends AxiosResponse {
  data: GetPropertyConfigsAPIResponseData
}

export function getPropertyConfigsAPI(
  axiosInstance: AxiosInstance,
): Promise<GetPropertyConfigsAPIResponse> {
  return axiosInstance({
    data: { avoidClientSideAuth: true },
    method: "get",
    url: "/home/property-config-type",
  }) as Promise<GetPropertyConfigsAPIResponse>
}
